import factoryDeliveryProgramApi from "@/api/person/factoryDeliveryProgramApi";

export default{
  namespaced: true,
  actions: {
    async fetch({dispatch}, {factoryId, groupId}) {
      try {
        const response = await factoryDeliveryProgramApi.fetch(factoryId, groupId);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async addOrUpdate({dispatch}, {factoryId, groupId, deliveryPrograms}) {
      try {
        const response = await factoryDeliveryProgramApi.addOrUpdateRange(factoryId, groupId, deliveryPrograms);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, { root: true});
      }
    }
  }
}
